export const BACKUP_TYPE_SHOW_RESET = 'BACKUP_TYPE_SHOW_RESET'
export const BACKUP_TYPE_SHOW_SET_ERROR = 'BACKUP_TYPE_SHOW_SET_ERROR'
export const BACKUP_TYPE_SHOW_SET_RETRIEVED = 'BACKUP_TYPE_SHOW_SET_RETRIEVED'
export const BACKUP_TYPE_SHOW_TOGGLE_LOADING = 'BACKUP_TYPE_SHOW_TOGGLE_LOADING'
